import { HOMEPAGE_FALLBACK_AD_LOADED } from '@web-platform/shared-universal-constants/src/redux/actions/render';
import { CONFIG_SERVICE_KEYS } from '@web-platform/shared-universal-constants-config';
import { APP_INIT } from '@web-platform/shared-universal-redux/src/actions/app';
import { COOKIE_BANNER_ACKNOWLEDGED } from '@web-platform/shared-universal-redux/src/actions/user';
import { getConfigServiceValue } from '@web-platform/shared-universal-utils-frontend/src/config';
import { getCulture } from '@web-platform/shared-universal-utils-frontend-localisation';
import { showCookieBanner, willShowConsentBanner } from 'saddlebag-tracking-preferences';

import { ADVERT_VISIBLE } from '../../../actions/adverts';

import type { Action } from '@web-platform/shared-universal-types/src/redux/banana/actions/actions-banana-types';
import type { YoloState } from '@web-platform/shared-universal-types/src/redux/banana/state/shared/yolo';

const initialState: YoloState = {
  adsLoaded: false,
  /**
   * Indicates if the cookie banner is open.
   * Despite being in the `yolo` namespace, it is used by more than just the `GoogleOneTap` component,
   * as such, extra care should be taken when updating.
   */
  cookieBannerClosed: false,
};

const yoloReducer = (state: YoloState = initialState, action: Action): YoloState => {
  switch (action.type) {
    case APP_INIT: {
      if (!action.payload) {
        return state;
      }

      const { market } = getCulture();
      const enableKetchCMP = !!getConfigServiceValue(CONFIG_SERVICE_KEYS.OPS.ENABLE_KETCH_CMP);
      // Mirror PageAddons gate: cookieBannerClosed must be false whenever a banner
      // is going to mount, so LoginAutoPrompt and other modals don't stack on top.
      // willShowConsentBanner() handles the already-consented Ketch case where
      // ConsentBanner mounts but renders nothing.
      const willShowSkyscannerBanner = showCookieBanner(market);
      const willShowKetchBanner = enableKetchCMP && willShowConsentBanner();

      return {
        ...state,
        cookieBannerClosed: !(willShowSkyscannerBanner || willShowKetchBanner),
      };
    }

    case ADVERT_VISIBLE:
    case HOMEPAGE_FALLBACK_AD_LOADED:
      return { ...state, adsLoaded: true };

    case COOKIE_BANNER_ACKNOWLEDGED:
      return { ...state, cookieBannerClosed: true };

    default:
      return state;
  }
};

export const isReadyToDisplay = (state: YoloState): boolean =>
  state.adsLoaded && state.cookieBannerClosed;
export const isCookieBannerClosed = (state: YoloState): boolean => state.cookieBannerClosed;
export default yoloReducer;
export const get = (state: YoloState): YoloState => state;
